import { Injectable } from '@angular/core';
import {Observable} from 'rxjs/Observable';
import {ApiService} from './api.service';

@Injectable()
export class VnaPortalService {

    constructor(private api: ApiService) { }

    getPortals(criteria?: Object): Observable<any> {
        return this.api.get('vna/portal', criteria);
    }
}



// WEBPACK FOOTER //
// /var/www/backend/src/app/core/service/vna-portal.service.ts